import React from 'react';

import RegistrationForm from 'shared-ui/components/registration-form/registration-form';
import SplitLayout from 'shared-ui/components/split-layout/split-layout';
import type { NamedFC } from 'shared-ui/named-fc.types';

import { Register as Props } from './register.props';

const Register: NamedFC<Props> = ({ layout, registrationForm }) => (
  <SplitLayout {...layout}>
    <div className="predefined-register">
      <RegistrationForm {...registrationForm} />
    </div>
  </SplitLayout>
);

Register.displayName = 'Register';

export default Register;
